<template>
	<div class="g-container">
		<div class="guide-title font-default">Guide</div>
		<div class="feet">
			<div class="foot leftFoot"></div>
			<div class="foot"></div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'LandmarkGuide'
	};
</script>

<style lang="scss" scoped>
	.g-container {
		border-radius: 16px;
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		grid-template-rows: 15% auto;
		@media screen and (orientation: portrait) {
			max-height: 20vh;
		}
		height: 30vh;
		.guide-title {
			font-weight: bolder;
			text-transform: uppercase;
			font-size: 0.8rem;
			margin-bottom: 5px;
		}

		.feet {
			@media screen and (orientation: portrait) {
				max-height: 20vh;
			}

			display: grid;
			grid-template-columns: 1fr 1fr;
			grid-gap: 5px;
			max-height: 250px;
			height: 100%;

			.foot {
				background: url('../../public/assets/images/footimg_landmarks_update.png') no-repeat;
				background-size: contain;
				position: relative;

				.rightMark {
					position: absolute;
					top: 25%;
					right: 10%;
				}

				.leftMark {
					position: absolute;
					top: 21%;
					left: 8%;
				}
			}

			.leftFoot {
				transform: scaleX(-1);
			}
		}
	}
</style>
